// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import router from './router';
import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VeeValidate, { Validator } from 'vee-validate';
import Truncate from 'lodash.truncate';
import store from './store/';
import './filters';
import VTooltip from 'v-tooltip';
import Chat from 'vue-beautiful-chat';
import VueRx from 'vue-rx'
import services from "./services/HttpService";
import JsonExcel from 'vue-json-excel';
Vue.component('downloadExcel', JsonExcel);
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
Vue.use(Chat);
Vue.use(VueRx)
Vue.use(VTooltip);
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
Vue.config.productionTip = false;
// Helpers
// Global filters
Vue.filter('truncate', Truncate);
// defining custom validation rules for vee-validate
Validator.extend('no_special_char', {
  getMessage: field => 'The ' + field + ' field doesn\'t accept special characters.',
  validate: function (value) {
    if (/[^a-zA-Z0-9_& \-\/]/.test(value)) {
      return false;
    }
    return true;  
  }
});
Validator.extend('custom_contact', {
  getMessage: field => 'The ' + field + ' field must be at least 10 characters.',
  validate: function (value) {
    if (value.length != 10) {
      return false;
    }
    return true;  
  }
});
Validator.extend('numeric_radius', {
  getMessage: field => 'The ' + field + ' may only contain numeric characters.',
  validate: function (value) {
    if((typeof value === 'string' && value !== 'ANY' &&  isNaN(value)) || (typeof value === 'object' && value.id !== 'ANY' &&  isNaN(value.id))){
      return false;
    }
    return true;  
  }
});

Validator.extend('city_dest_address', {
  getMessage: field => 'The ' + field + ' field is Invalid.',
  validate: function (value) {
      if (value != '') {
          return false;
      }
      return true;
  }
});

Validator.extend('restrictedWord', {
  getMessage: field => 'Some Bad Words In Your ' + field + '!',
  validate: function (value) {
      let restrictedWord = "anal|anus|arse|ass|fuck|ass hole|assfucker|asshole|assshole|bastard|bitch|black cock|"
      restrictedWord += "bloodyhell|boong|cock|cockfucker|cocksuck|cocksucker|coonnass|crap|cunt|cyberfuck|damn|dar\|"
      restrictedWord += "dick|dirty|douche|dummy|erect|erection|erotic|escort|fag|faggot|fuck|Fuck off|fuck you|"
      restrictedWord += "fuckass|fuckhole|god damn|hard core|hardcore|h omoerotic|hore|lesbian|lesbians|"
      restrictedWord += "mother fucker|motherfuck|motherfucker|orgasm|penis|penis fucker|piss|piss off|porn|"
      restrictedWord += "porno|pornography|pussy|retard|sadist|sex|sexy|shit|slut|son of a bitch|suck|tits|"
      restrictedWord += "viagra|whore|xxx|mic|wop|jap|chink|nip. squint kike|chink|cracker|gook|honkey|negro|nigger|"
      restrictedWord += "sandnigger|spic|whitey|wetback|wigger tar baby|spear chucker|slope|hooknose|jiggaboo|"
      restrictedWord += "jigga|kraut|cracker|niggers|spics|pakis|chinks|nips|krauts|frogs|wops|wogs|paddies|"
      restrictedWord += "limeys|polaks|kikes|dune coons|gooks"
      //https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch05s02.html
      let regex = new RegExp("\\b(?:" + restrictedWord + ")\\b", "gi");
      if(value.match(regex)){
        return false;
      }
      return true;
  }
});

const options = {}; 
Vue.use(VeeValidate, {fieldsBagName: 'formFields'});
Vue.use(require('vue-moment'));
Vue.use(Vuetify, {
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {
      },
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: '',
    }
  }
});
// Bootstrap application components

router.beforeEach((to, from, next) => {
  document.title = 'LOADMAX - ' + to.meta.title;
  next();
});

services.checkValidToken();
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js